<template>
    <div>
        <div class="pageNavArea" :class="getBg()" v-if="showBanner">
            <!-- pc屏幕 -->
            <div class="d-sm-none d-xl-block">
                <div class="page-nav flex align-center">
                    <div class="page-nav-title">{{ title }}</div>
                </div>
            </div>
            <!-- h5 -->
            <div class="d-sm-block d-xl-none">
                <div class="sm-page-nav flex align-center justify-center">
                    <div class="page-nav-title">{{ title }}</div>
                </div>
            </div>
        </div>
        <!-- pc -->
        <div class="nav-list-line d-sm-none d-xl-block" ref="navLine" :class="{ 'isFixed': isFixed }">
            <div class="nav-list">
                <b-container fluid>
                    <b-row>
                        <b-col xl="12">
                            <div class="nav-list-scroll flex align-center">
                                <div class="nav-list-item" :class="{ 'active-nav-item': currentIndex == index }"
                                    v-for="(item, index) in navList" :key="index" @click="navClick(item, index)">
                                    {{ item[navLabelKey] }}
                                </div>
                            </div>
                        </b-col>
                    </b-row>
                </b-container>
            </div>
        </div>
        <!-- h5 -->
        <div class="sm-nav-list-line d-sm-block d-xl-none"  ref="smnavLine"  :class="{ 'isFixed': isFixed }">
            <div class="nav-list">
            <div class="nav-list-scroll flex align-center" ref="smNavLineScroll">
                                <div class="nav-list-item" :class="{ 'active-nav-item': currentIndex == index }"
                                    v-for="(item, index) in navList" :key="index" @click="navClick(item, index)"  >
                                    {{ item[navLabelKey] }}
                                </div>
                            </div>
                            </div>
        </div>
        <!-- 显示导航栏 -->
        <div class="nav-list-line" ref="breadNavLine" :class="{ 'isFixed': (isFixed&&!isDetail)||isDetail }">
            <div class="nav-list">
            <div class="nav-list-scroll  breadcrumbsList-scroll flex align-center">
                                <div class="breadcrumbsList-item" 
                                    v-for="(item, index) in breadcrumbsList" :key="index" @click="navCrumbsClick(item, index)">
                                    <span>{{ item.title }}</span>
                                    <span v-if="index!=breadcrumbsList.length-1" class="breadcrumbs-icon"> > </span>
                                </div>
                            </div>
                            </div>
        </div>
        <div v-if="(isFixed&!isDetail)||isDetail" class="pla-line"></div>
        <!-- <div v-if="isFixed" class="pla-line2 d-sm-block d-xl-none"></div> -->
    </div>
</template>
<script>
export default {
    props: {
        type: {
            type: Number,
            default: 0 //0 人才招聘
        },
        title: {
            type: String,
            default: ''
        },
        navList: {
            type: Array,
            default: () => {
                return []
            }
        },
        navLabelKey: {
            type: String,
            default: 'title'
        },
        breadcrumbsList:{
            type:Array,
            default:()=>{
                return []
            }
        },
        showBanner:{
            type:Boolean,
            default:true
        },
        current:{
            type:Number,
            default:0
        },
        isDetail:{
            type:Boolean,
            default:false
        }
    },
    data() {
        return {
            currentIndex: 0,
            navLineTop: 0,
            isFixed: false
        }
    },
    mounted() {
        this.$nextTick(() => {
        // setTimeout(()=>{
        //     console.log(this.$refs.navLine.clientHeight)
        // console.log(this.$refs.smnavLine.clientHeight)
        // },500)
            if(this.$refs.navLine.clientHeight!=0){
                this.navLineTop = this.$refs.navLine.offsetTop
            }else if(this.$refs.smnavLine.clientHeight!=0){
                this.navLineTop = this.$refs.smnavLine.offsetTop
            }else {
                this.navLineTop =this.$refs.breadNavLine.offsetTop
            }
            window.addEventListener("scroll", this.handleScroll)
        })
    },
    destroyed(){
        window.removeEventListener("scroll", this.handleScroll)
    },
    methods: {
        getBg() {
            return 'bg' + (this.type + 1)
        },
        navClick(item, index) {
            this.$emit('navClick', { item: item, index: index })
        },
        handleScroll(e) {
            let nowTop = e.target.scrollTop || document.documentElement.scrollTop;
            this.isFixed = (nowTop - this.navLineTop + 67 > 0) ? true : false
            if(this.isFixed){
                this.$emit('changeFixed',true)
            }else{
                this.$emit('changeFixed',false)
            }
        },
        navCrumbsClick(item,index){
            if(item.url){
                this.$router.push({path:item.url})
            }else{
                this.$emit('navCrumbsClick', { item: item, index: index })
            }
        }
    },
    watch:{
        current(newVal){
            this.currentIndex=newVal
            if(this.currentIndex>3&&this.navList.length>=4){
                this.$refs.smNavLineScroll.scrollLeft=this.$refs.smNavLineScroll.scrollLeft +300
            }else{
                this.$refs.smNavLineScroll.scrollLeft=0
            }
        }
        
    },
}
</script>
<style scoped lang="scss">
.pageNavArea {
    width: 100%;
    // min-height: 450px;
    background-size: 100% 100%;
    z-index: 30;
        position: relative;
}

.bg1 {
    background-image: url('../assets/image/pageNavBg.png');
}

.page-nav {
    // width: 1080px;
    width: 1280px;
    height: 450px;
    margin: 0 auto;

    .page-nav-title {
        font-family: 'SourceHanSansCN-Regular';
        font-weight: bold;
        font-size: 75px;
        color: #333333;
        line-height: 113px;
        /* padding-left: 30px;*/
    }
}

/* h5*/
.sm-page-nav {
    height: 300px;
    z-index: 30;
        position: relative;
    .page-nav-title {
        display: inline-block;
        padding: 40px 100px;
        background: rgba(255, 255, 255, 0.5);
        font-family: 'SourceHanSansCN-Regular';
        font-weight: bold;
        font-size: 72px;
        color: #333333;
    }
}

.nav-list-line,.sm-nav-list-line {
    background: #fff;
    box-shadow: 0px 3px 30px 2px rgba(10,49,128,0.2);
    .nav-list {
        // max-width: 1080px;
        max-width: 1200px;
        margin: 0 auto;
        background: #fff;
        // .breadcrumbsList-scroll{
        //     border-bottom: 1px solid #e0e0e0;
        // }
        .nav-list-scroll {
            overflow-x: auto;
            overflow-y: hidden;

            .nav-list-item {
                padding: 20px 20px;
                font-family: 'SourceHanSansCN-Regular';
                font-weight: 400;
                // font-size: 18px;
                font-size: 24px;
                color: #333333;
                user-select: none;
                cursor: pointer;
                flex-shrink: 0;
                white-space:pre-wrap
            }

            .active-nav-item {
                background: #1566D4;
                color: #fff;
            }
            .breadcrumbsList-item{
                font-family: 'SourceHanSansCN-Regular';
font-weight: 400;
font-size: 18px;
color: #333333;
line-height: 67px;
user-select: none;
cursor: pointer;
.breadcrumbs-icon{
    margin: 0 6px;
}
            }
            .breadcrumbsList-item:first-of-type{
                padding-left: 20px;
            }
        }
    }
}
/*h5 */
.sm-nav-list-line{
    width: 100%;
    z-index: 30;
        position: relative;
    .nav-list {
        width: 100%;
        max-width: none;
        overflow-x: auto;
        border-bottom: 1px solid #e0e0e0;
        .nav-list-item{
            // flex: 1;
            min-width: 168px;
            flex-shrink: 0;
            // min-width: 200px;
            text-align: center;
            padding: 20px 32px;
                font-size: 26px!important;
        }
    }
}
.isFixed {
    position: fixed;
    left: 0;
    top: 95px;
    width: 100%;
    z-index: 80;
}

.pla-line {
    height: 67px;
    width: 100%;
}

::-webkit-scrollbar {
    // height: 5px;
    height: 0;
}

/* 定义滚动条轨道 */
::-webkit-scrollbar-track {
    //   -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.5);
    border-radius: 10px;
    background-color: #FFF;
}


/* 滑块 */
::-webkit-scrollbar-thumb {
    border-radius: 10px;
    -webkit-box-shadow: #1566D4;
    background-color: #1566D4;
}

// 移动端
@media (min-width: 576px)and (max-width:1200px){
    .breadcrumbsList-scroll{
    .breadcrumbsList-item{
        span{
            font-size: 26px;
        }
    }
}
}
</style>